import React from 'react';
import { Grid, TextField, MenuItem, Typography, Box, FormControl, InputLabel, Select, FormHelperText } from '@mui/material';
import { surgeonOptions, anesthetistOptions, assistantOptions } from '../../constants/options';

const TeamSection = ({ formData, handleChange, errors }) => {
  return (
    <Box sx={{ mt: 3 }}>
      <Typography variant="h6" sx={{ color: '#008080', mb: 2, fontWeight: 'bold' }}>
        Step 3: Medical Team & Anesthesia
      </Typography>
      
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth size="small" error={!!errors.name_of_surgeon} required sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
            <InputLabel>Name of Surgeon</InputLabel>
            <Select
              name="name_of_surgeon"
              value={formData.name_of_surgeon || ''}
              label="Name of Surgeon"
              onChange={handleChange}
            >
              {surgeonOptions.map(opt => <MenuItem key={opt} value={opt}>{opt}</MenuItem>)}
            </Select>
            {errors.name_of_surgeon && <FormHelperText>{errors.name_of_surgeon}</FormHelperText>}
          </FormControl>
        </Grid>
        
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth size="small">
            <InputLabel>Assisted By</InputLabel>
            <Select
              name="assisted_by"
              value={formData.assisted_by || ''}
              label="Assisted By"
              onChange={handleChange}
            >
              {assistantOptions.map(opt => <MenuItem key={opt} value={opt}>{opt}</MenuItem>)}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6}>
          <FormControl fullWidth size="small" error={!!errors.name_of_anesthesiologist} required sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
            <InputLabel>Anesthesiologist</InputLabel>
            <Select
              name="name_of_anesthesiologist"
              value={formData.name_of_anesthesiologist || ''}
              label="Anesthesiologist"
              onChange={handleChange}
            >
              {anesthetistOptions.map(opt => <MenuItem key={opt} value={opt}>{opt}</MenuItem>)}
            </Select>
            {errors.name_of_anesthesiologist && <FormHelperText>{errors.name_of_anesthesiologist}</FormHelperText>}
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            select
            label="Type of Anesthesia"
            fullWidth
            size="small"
            name="type_of_anesthesia"
            value={formData.type_of_anesthesia || ''}
            onChange={handleChange}
            required
            InputLabelProps={{ sx: { '& .MuiFormLabel-asterisk': { color: 'red' } } }}
            error={!!errors.type_of_anesthesia}
            helperText={errors.type_of_anesthesia}
          >
            {["GA", "Spinal", "Epidural", "Local", "Regional"].map(type => <MenuItem key={type} value={type}>{type}</MenuItem>)}
          </TextField>
        </Grid>

        <Grid item xs={12} sm={6}>
          <FormControl fullWidth size="small" error={!!errors.scrubbed_nurse} required sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
            <InputLabel>Scrubbed Nurse</InputLabel>
            <Select
              name="scrubbed_nurse"
              value={formData.scrubbed_nurse || ''}
              label="Scrubbed Nurse"
              onChange={handleChange}
            >
              {assistantOptions.map(opt => <MenuItem key={opt} value={opt}>{opt}</MenuItem>)}
            </Select>
            {errors.scrubbed_nurse && <FormHelperText>{errors.scrubbed_nurse}</FormHelperText>}
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6}>
          <FormControl fullWidth size="small">
            <InputLabel>Circulating Nurse</InputLabel>
            <Select
              name="circulating_nurse"
              value={formData.circulating_nurse || ''}
              label="Circulating Nurse"
              onChange={handleChange}
            >
              {assistantOptions.map(opt => <MenuItem key={opt} value={opt}>{opt}</MenuItem>)}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    </Box>
  );
};

export default TeamSection;
